// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2I3OI","box":"WorkspacesBox_box__8MDRZ","node":"WorkspacesBox_node__3vu7p"};